import { useEffect, useState } from "react";
import ToDo from "./components/ToDo";
import { addToDo, getAllToDo, updateToDo, deleteToDo } from "./utils/HandleApi";


function App() {

  const [toDo, setToDo] = useState([])
  const [text, setText] = useState("")
  const [isUpdating, setIsUpdating] = useState(false)
  const [toDoId, setToDoId] = useState("")

  useEffect(() => {
    getAllToDo(setToDo)
  }, [])

  const updateMode = (_id, text) => {
    
    setIsUpdating(true) 

    setText(text)
    setToDoId(_id)
  }

  return (
    <div className="App">

      {/*container for todoapp and add todos*/}
      <div className="container">
      <h1>ToDoApp</h1>
        <div className="top">
          <input type="text" 
          placeholder="Add ToDos..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          />

          {/*add button and give it on click functionality to make it work*/}
          <div 
          className="add" 
          onClick={isUpdating ? 
            () =>updateToDo(toDoId, text, setToDo, setText, setIsUpdating) 
            : () => addToDo(text, setText, setToDo)}>
            {/*if it is updating it should say update, if it is adding it should say add*/}
            {isUpdating ? "Update" : "Add"}
            </div>
        </div>

        <div className="list">

           {/*I think this grabs each item or todo list item*/}
          {toDo.map((item) => <ToDo 
          key={item._id} 
          text={item.text} 
          updateMode={() => updateMode(item._id, item.text)}
          deleteToDo={() => deleteToDo(item._id, setToDo)}/>)}
      
        </div>
 
      </div>

    </div>
  );
}

export default App;
